import { forwardRef, useState } from 'react';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useTranslation } from 'react-i18next';

import { IconButton } from '../Buttons/IconButton';

import { TextInput } from './TextInput';
import type { TextInputProps } from './TextInput';

export type PasswordInputProps = Omit<TextInputProps, 'type' | 'endAdornment' | 'clearable' | 'onClear' | 'multiline'>;

export const PasswordInput = forwardRef<HTMLDivElement, PasswordInputProps>(function PasswordInput({ autoComplete = 'current-password', ...rest }, ref) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const VisibilityIcon = visible ? VisibilityOff : Visibility;
  return (
    <TextInput
      ref={ref}
      type={visible ? 'text' : 'password'}
      autoComplete={autoComplete}
      endAdornment={
        <IconButton
          edge="end"
          label={t('coreComponents.fields.showPassword', 'Show password')}
          aria-pressed={visible}
          onClick={() => setVisible((v) => !v)}
          onMouseDown={(e) => e.preventDefault()}
        >
          <VisibilityIcon fontSize="small" />
        </IconButton>
      }
      {...rest}
    />
  );
});
